import React, { useEffect, useState } from "react";
import Chatform from "./Chatform";
import {
  Iconography,
  Loader,
  LoaderSizes,
  Typography,
  TypographyVariant,
} from "@hid-galaxy-ui/galaxy-react";
import Sidenav from "../Reusable/Sidenav";
import { LogoutPath } from "../routes";
import { getText } from "../__utils__/textUtils";
import { NavItem, transformedNavItems } from "../__utils__/navUtils";
import { getAuthToken, getUserInfo } from "../utils";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, TENANT_ID } from "../utils/common";
import Header from "../Reusable/Header";

const Chatbot = () => {
  const [chatStarted, setChatStarted] = useState<boolean>(false);
  const [navItems, setNavItems] = useState<NavItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedConversation, setSelectedConversation] = useState<
    string | null
  >(null);
  const [chatKey, setChatKey] = useState(Date.now());
  const [isMobileSidenavOpen, setIsMobileSidenavOpen] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const fetchSidenav = async () => {
    const response = await fetch(`${API_BASE_URL}/conversations/sessions`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAuthToken()}`,
        "x-tenant-id": TENANT_ID || "",
      },
    });
    if (response.status === 401) {
      navigate(LogoutPath);
      return;
    }
    const data = await response.json();
    setNavItems(transformedNavItems(data));
    setLoading(false);
  };
  useEffect(() => {
    fetchSidenav();
  }, []);
  const handleNewChat = () => {
    setSelectedConversation(null);
    setChatStarted(false);
    setChatKey(Date.now());
  };
  const userInfo = (() => {
    try {
      return JSON.parse(getUserInfo());
    } catch {
      return {};
    }
  })();
  const handleUserAction = (action: string) => {
    if (action === "logout") {
      navigate(LogoutPath);
    }
  };

  const handleMobileMenuToggle = () => {
    setIsMobileSidenavOpen(!isMobileSidenavOpen);
  };

  return (
    <div className="hid-full-height">
      <Header onMenuToggle={handleMobileMenuToggle} onNewChat={handleNewChat} />
      <div className="hid-container">
        {/* Mobile overlay to close sidenav when clicking outside */}
        {isMobileSidenavOpen && (
          <div
            className="mobile-sidenav-overlay"
            onClick={() => setIsMobileSidenavOpen(false)}
          />
        )}
        <div className="hid-fixed-container">
          <div
            className={`mobile-sidenav ${
              isMobileSidenavOpen ? "mobile-sidenav--open" : ""
            }`}
          >
            <Sidenav
              id="hid-sidenav"
              selected={navItems[0]?.key}
              navItems={navItems}
              isToggle={true}
              onNewChat={handleNewChat}
              username={userInfo.given_name || "User"}
              onUserAction={handleUserAction}
              forceExpanded={isMobileSidenavOpen}
              children={
                loading ? (
                  <div className="hid-side-loader">
                    <Loader variant={LoaderSizes.medium} />
                  </div>
                ) : null
              }
              onNodeClick={(e, nodekey) => {
                setSelectedConversation(nodekey);
                // Close mobile sidenav when clicking on a nav item
                setIsMobileSidenavOpen(false);
              }}
            />
          </div>
          <div className="hid-flex hid-fixed-container__main">
            <div
              className={`hid-main-container ${
                chatStarted ? "chat-started" : ""
              }`}
            >
              <Chatform
                key={chatKey}
                setChatStarted={setChatStarted}
                selectedConversation={selectedConversation}
                refreshSidenav={fetchSidenav}
              />
              <footer className="chatbot-footer">
                <Iconography icon="circleInfo" />
                <Typography
                  variant={TypographyVariant.H4}
                  children={getText("FOOTER_MESSAGE")}
                />
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
